import { useQuery } from '@tanstack/react-query'

import { fetchReleasesService } from '../services/fetch-releases.service'

export const useFetchReleasesQuery = () =>
  useQuery({
    queryFn: () => fetchReleasesService({ limit: 10, page: 1 }),
    queryKey: ['fetch-releases'],
    staleTime: 1000 * 60 * 3, // 3 minutes
  })
